import useOperationLoadingState from '../hooks/use-operation-loading-state'

export default function WhenNotLoading (props) {
  const [isLoading] = useOperationLoadingState()

  return (isLoading === false) ? props.children : null
}
